// Global Instructions Rule Applied!

import { MainState } from '../../interfaces/deals.ts'
import { DealFields } from '../../data_models/deal_record.ts'

/**
 * Selector function to find a deal by ID in both pipeline.data and deal.data arrays
 * Searches pipeline.data first, then deal.data
 * Returns the first match found, or undefined if not found
 *
 * Usage:
 * const deal = useSelector((state) => selectDealById(state, dealId))
 */
export const selectDealById = (state: { deals: MainState }, dealId: string | number | null | undefined) => {
  if (!dealId || !state.deals) return undefined

  const dealIdString = dealId.toString()

  // Search pipeline.data first
  const pipelineDeal = state.deals.pipeline.data.find((deal) => deal[DealFields.deals__id]?.toString() === dealIdString)

  if (pipelineDeal) {
    return pipelineDeal
  }

  // If not found in pipeline, search deal.data
  const dealDeal = state.deals.deal.data.find((deal) => deal[DealFields.deals__id]?.toString() === dealIdString)

  return dealDeal
}
